export default "__VITE_ASSET__DR5kbVKs__"